import styled, { css } from 'styled-components';

import { mediaQuery, Tag } from '@catalyze/ui';

export const StyledNewTag = styled(Tag)`
    display: none;
    ${mediaQuery(
        2,
        css`
            display: flex;
            justify-content: center;
            align-items: center;
            grid-area: badge;
            padding: 0.375rem;
        `
    )}
`;

export const StyledNewMobileTag = styled.div`
    width: 0.5rem;
    height: 0.5rem;
    background: ${({ theme }) => theme.colors.logoPrimary};
    border-radius: 50%;
    justify-self: flex-end;
    align-self: center;
    ${mediaQuery(
        2,
        css`
            display: none;
        `
    )}
`;
